import React from 'react';

const EmailInput = (props) => {
  return (
      <input type="email" className="form-control" maxLength="100" {...props} />
  );
}

export default EmailInput;
